// @ts-nocheck

import clsx from 'clsx'
import { Row } from 'react-table'

interface Prop {
  row: Row
  rowKey?: string
  onClickRow?: (id: string, e: Event) => void

  isGrey?: boolean
}

const CustomRow: React.FC<Prop> = ({ row, rowKey, onClickRow, isGrey }) => {
  return (
    <tr
      {...row.getRowProps()}
      onClick={(e: any) => {
        if (onClickRow && rowKey) {
          onClickRow(row.original[rowKey], e)
        }
      }}
      className={clsx({ 'bg-gray-100': row.isSelected || isGrey }, 'cursor-pointer')}>
      {row.cells.map(cell => {
        let className: React.CSSProperties = {
          width: cell.column.width,
          minWidth: cell.column.minWidth,
          maxWidth: cell.column.maxWidth,
        }

        return (
          <td
            data-label={cell.column.Header}
            {...cell.getCellProps()}>
            {cell.render('Cell')}
          </td>
        )
      })}
    </tr>
  )
}

export default CustomRow
